import $ from 'jquery';
import init from "../init";
import barba from '@barba/core';
import locoScroll from "./locoScroll";
import {getWidth} from "../utils/window";

const $pageLoadingContainer = $('.page-loading'),
	$hamburger = $('.hamburger'),
	$hamburgerLabel = $('.hamburger-label');

let scroll;
let lazyLoad;
let btt;
let animateOnEvents = 'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd';


export default function barbaSetup() {
	const $wrapper = $('[data-barba="wrapper"]');

	if ($wrapper.length) {

		beforeInitHooks();
		barba.init({
			transitions: [
				{
					once(data) {
						// init LocomotiveScroll on page load
						checkHamLabel(data);
						smooth(data.next.container);
						modalLinks();
					},
					beforeEnter(data) {
						scroll.stop();
						scroll.destroy();
						lazyLoad.destroy();
					},
					before(data) {
						return new Promise(function(resolve) {
							if ($hamburger.hasClass('is-active')) {
								$hamburger.click();
							}
							resolve();
							// loadOpen(resolve);
						});
					},
					// beforeLeave(data) {
					// },
					leave(data) {
						// create your stunning leave animation here
						if (getWidth() < 1080) {
							// $('html,body').scrollTop(0);
							scroll.scrollTo('top');
						}
						checkHamLabel(data);
					},
					enter(data) {
						// create your amazing enter animation here
					},
					after(data) {
						init(data.next.container);
						smooth(data.next.container);
						modalLinks();
						// loadClose();
						$('#content').addClass('-show');
					},
					// afterEnter(data) {
						// scroll.update();
						// loadClose();
					// }
				}
			],
		});
		afterInitHooks();
	}
}

function beforeInitHooks() {
	// btt = $('.footer-main-btt_button');
	barba.hooks.after(() => {
		if (window.ga) {
			ga('set', 'page', window.location.pathname);
			ga('send', 'pageview');
		}
		if (window.fbq) fbq('track', 'PageView');
	});
}

function afterInitHooks() {
	// barba.hooks.beforeEnter((data) => {
		// initialise the JS for the new container
		// init(data.next.container);
	// });
}

function smooth(container) {
	if (container) {
		// links to ignore
		let url = window.location.href + 'modal';
		$('[href^="' + url + '"]').attr('data-barba-prevent', 'self');
		$('[href^="#"]').attr('data-barba-prevent', 'self');
	}

	const els = locoScroll()
	scroll = els.scroll;
	lazyLoad = els.lazy;
}

function modalLinks() {
	const url = $('#modal').attr('data-url');
	$(`a[href^="${url}"]`).attr('target', 'modal-frame');
}

// function loadOpen(resolve) {
// 	$pageLoadingContainer.removeClass('-closed');
// 	setTimeout(()=>{
// 		resolve();
// 	}, 1000);
// }
//
// function loadClose() {
// 	$pageLoadingContainer.addClass('-closing');
// 	setTimeout(()=>{
// 		$pageLoadingContainer.addClass('-closed').removeClass('-closing');
// 	}, 1000);
// }

function checkHamLabel(data) {
	if ($(data.next.container).find('#content.homepage').length) {
		$hamburgerLabel.removeClass('-hide');
	} else {
		$hamburgerLabel.addClass('-hide');
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/barba.js